// extracted by mini-css-extract-plugin
export default {"recos":"p5-z","productCardOverride":"q5-z","rowHasBadge":"r5-z"};